const appConfig = {
    homeSiteApiUrl: 'https://homesite-api.herokuapp.com/api', 
    altHomeSiteApiUrl: 'http://localhost:5002/api'
}

export default appConfig